/***************************************************************************************************
** useTitle
***************************************************************************************************/

import { useRef } from "react";

export default function useTitle(title) {
  const prevTitleRef = useRef(document.title);

  if (title !== document.title) {
    document.title = title;
  }

  if (!title) {
    document.title = prevTitleRef.current;
  }
}
